import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavOptions from './NavOptions';
import NavContent from './NavContent';
import { openExternalLink, showUmoExternalLink } from '../../utils/uiUtils';
import appConfig from '../../appConfig';

/** @param {{APP_VERSION:string}} saved search */
class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedComponent: undefined,
    };

    this.onClick = this.onClick.bind(this);
    this.onCollapse = this.onCollapse.bind(this);
    this.onExternalLinkClick = this.onExternalLinkClick.bind(this);
  }

  onClick(component) {
    if (component) {
      let expand = true;

      if (this.state.selectedComponent && component.type === this.state.selectedComponent.type) {
        expand = false;
        this.setState({ selectedComponent: undefined });
      } else {
        this.setState({ selectedComponent: component });
      }

      this.props.onNavExpand(expand);
    }
  }

  onCollapse() {
    this.setState({ selectedComponent: undefined });
    this.props.onNavExpand(false);
  }

  onExternalLinkClick(link) {
    this.onCollapse();
    if (link.ext) {
      openExternalLink(link.url, false);
    } else {
      showUmoExternalLink(this.props.dispatch, link.url);
    }
  }

  render() {
    return (
      <div
        className={classNames(
          'main__nav',
          { 'main__nav--workspace-open': this.props.isWorkspaceExpanded },
          { 'main__nav--labels': appConfig.displayNavBarLabels }
        )}
      >
        <NavOptions
          isNavExpanded={this.props.isNavExpanded}
          selectedComponent={this.state.selectedComponent}
          onClick={this.onClick}
          onExternalLinkClick={this.onExternalLinkClick}
          dispatch={this.props.dispatch}
          onHomeClick={this.props.onHomeClick}
        />
        <NavContent
          isNavExpanded={this.props.isNavExpanded}
          selectedComponent={this.state.selectedComponent}
          onCollapse={this.onCollapse}
          isWorkspaceExpanded={this.props.isWorkspaceExpanded}
        />
        <span className="main__nav-version">v{APP_VERSION}</span>
      </div>
    );
  }
}

Nav.propTypes = {
  isWorkspaceExpanded: PropTypes.bool,
  isNavExpanded: PropTypes.bool,
  onNavExpand: PropTypes.func,
  dispatch: PropTypes.func,
  onHomeClick: PropTypes.func,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/js/components/Nav/index.jsx